import Vue from 'vue'
import Vuex from 'vuex'

import {read, utils} from 'xlsx';

Vue.use(Vuex)

let URL = '';
const testBuild = false;
if(!testBuild){
  URL = 'https://hspm.ru/studentam/raspisaniye-zanyatiy';
} else {
  URL = 'http://192.168.1.170:8080/timetable/';
  //URL = 'http://192.168.0.8:8080/timetable/';
}
async function request(URL){
  const response = await fetch(URL);
  return await response.text();
}

//Поиск ссылки для очников (1 или 2 семестр)
function cutLinkOchSemestr(institute, body) {
  let link = '';
  let nbody = '';
  if(body.includes('Расписание занятий I') || body.includes('Расписание занятий II')){
    let abody = body?.split(`Расписание занятий II`)?.[1] || body?.split(`Расписание занятий I`)?.[1];
    nbody = abody.split(`${institute}</strong>`)?.[1]// || abody.split(`${institute}</strong>`)?.[1];
  }
  link = nbody?.slice(nbody.indexOf('<a ')+9, nbody.indexOf('" target="_blank"')) || ``;
  //console.log(1, `https://hspm.ru/${link}`)
  return (link) ? `https://hspm.ru/${link}`: ``;
}

//Поиск ссылки для вечерников (1 или 2 семестр)
function cutLinkOchZaochSemestr(institute, body) {
  let link = '';
  let nbody = '';
  if(body.includes('Расписание занятий I') || body.includes('Расписание занятий II')){
    let abody = body.split(`Расписание занятий II`)?.[1] || body.split(`Расписание занятий I`)?.[1];
    nbody = abody.split(`${institute}</strong>`)?.[1]// || abody.split(`${institute}</strong>`)?.[1];
  }
  link = nbody?.slice(nbody.indexOf('<a ', nbody.indexOf('<a ')+1)+9, nbody.indexOf('" target="_blank"', nbody.indexOf('" target="_blank"')+1)) || ``;
  //console.log(2, `https://hspm.ru/${link}`)
  return (link) ? `https://hspm.ru/${link}`: ``;
}

//Поиск ссылки для очников (зимняя или летняя сессия)
function cutLinkOchSession(institute, body) {
  let link = '';
  let nbody = '';
  if(body.includes('Расписание экзаменов I') || body.includes('Расписание экзаменов II')){
    let abody = body?.split(`Расписание экзаменов`)?.[1]
    let bbody = abody?.slice(0, abody.indexOf(`Весенняя сессия</strong>`));
    nbody = bbody.split(`${institute}</strong>`)?.[1] || bbody.split(`${institute}</strong>`)?.[1];
    link = nbody?.slice(nbody.indexOf('<a ')+9, nbody.indexOf('" target="_blank"'));
  }
  //console.log(3, `https://hspm.ru/${link}`)
  return (link) ? `https://hspm.ru/${link}`: ``;
}

//Поиск ссылки для вечерников (зимняя или летняя сессия)
function cutLinkOchZaochSession(institute, body) {
  let link = '';
  let nbody = '';
  if(body.includes('Расписание экзаменов I') || body.includes('Расписание экзаменов II')){
    let abody = body?.split(`Расписание экзаменов`)?.[1]
    let bbody = abody?.slice(0, abody.indexOf(`Весенняя сессия</strong>`));
    nbody = bbody.split(`${institute}</strong>`)?.[1] || bbody.split(`${institute}</strong>`)?.[1];
    link = nbody?.slice(nbody.indexOf('<a ', nbody.indexOf('<a ')+1)+9, nbody.indexOf('" target="_blank"', nbody.indexOf('" target="_blank"')+1));
  }
  //console.log(4, `https://hspm.ru/${link}`)
  return (link) ? `https://hspm.ru/${link}`: ``;
}
  
//Поиск ссылок для очников (весенняя сессия)
function cutLinkOchSpringSession(institute, body) {
  let link = '';
  let nbody = '';
  if(body.includes('Расписание экзаменов I') || body.includes('Расписание экзаменов II')){
    let abody = body?.split(`Весенняя сессия</strong>`)?.[1]
    nbody = abody.split(`${institute}</strong>`)?.[1] || abody.split(`${institute}</strong>`)?.[1];
  }
  link = nbody?.slice(nbody.indexOf('<a ')+9, nbody.indexOf('" target="_blank"'));
  //console.log(5, `https://hspm.ru/${link}`)
  return (link) ? `https://hspm.ru/${link}`: ``;
}

//Поиск ссылок для вечерников (весенняя сессия)
function cutLinkOchZaochSpringSession(institute, body) {
  let link = '';
  let nbody = '';
  if(body.includes('Расписание экзаменов I') || body.includes('Расписание экзаменов II')){
    let abody = body?.split(`Весенняя сессия</strong>`)?.[1]
    nbody = abody.split(`${institute}</strong>`)?.[1] || abody.split(`${institute}</strong>`)?.[1];
    link = nbody?.slice(nbody.indexOf('<a ', nbody.indexOf('<a ')+1)+9, nbody.indexOf('" target="_blank"', nbody.indexOf('" target="_blank"')+1));
  }
  //console.log(6, `https://hspm.ru/${link}`)
  return (link) ? `https://hspm.ru/${link}`: ``;
}

function cutLinkSemImtOch(){
  const a = `raspisaniye-studentov-ochnoy-formy-imt-vshpm-i-polugodiye-2026-2027-uch_20260918135052.xlsx`;
  return (a) ? (URL + a) : '';
}
function cutLinkSemIptoOch(){
  const a = `raspisaniye-studentov-ochnoy-formy-iptio-vshpm-i-polugodiye-2026-2027-uch_20260918135124.xls`;
  return (a) ? (URL + a) : '';
}
function cutLinkSemImtVech(){
  const a = `raspisaniye-studentov-ochno-zaochnoy-formy-imt-vshpm-i-polugodiye-2026-2027-uch_20260918135109.xls`;
  return (a) ? (URL + a) : '';
}
function cutLinkSemIptoVech(){
  const a = `raspisaniye-studentov-ochno-zaochnoy-formy-iptio-vshpm-i-polugodiye-2026-2027-uch_20260918135141.xls`;
  return (a) ? (URL + a) : '';
}
function cutLinkSesImtOch(){
  const a = ``;//`sessimtoch_20260605113850.xlsx`//`Расписание Зимней сессии ВШПМ СПбГУПТД (Очная ф.о.) ИМТ_20251226140357.xls`;
  return (a) ? (URL + a) : '';
}
function cutLinkSesIptoOch(){
  const a = ``;//`sessprptiooch_20260605113923.xlsx`//`Расписание Зимней сессии ВШПМ СПбГУПТД (Очная ф.о.) ИПТО_20251226140441.xlsx`;
  return (a) ? (URL + a) : '';
}
function cutLinkSesImtVech(){
  const a = ``;//`sessimtvech_20260605113905.xlsx`//`Расписание Зимней сессии ВШПМ СПбГУПТД (Очно-заочная ф.о.) ИМТ_20251226140415.xlsx`;
  return (a) ? (URL + a) : '';
}
function cutLinkSesIptoVech(){
  const a = ``;//`sessprptiovech_20260605113937.xlsx`//`Расписание Зимней сессии ВШПМ СПбГУПТД (Очно-заочная ф.о.) ИПТО_20251226140607.xls`;
  return (a) ? (URL + a) : '';
}
function cutLinkSprImtOch(){
  const a = ``;//`Расписание весенней сессии ВШПМ ИМТ СПбГУПТД (Очная ф.о.) 2025-2026 уч.года.xls`//`Расписание весенней сессии ВШПМ СПбГУПТД ИМТ (Очная ф.о.) 2024-2025 уч.года.xls`;
  return (a) ? (URL + a) : '';
}
function cutLinkSprIptoOch(){
  const a = ``;//`Расписание весенней сессии ВШПМ ИПТО СПбГУПТД (Очная ф.о.) 2025-2026 уч.года.xls`//`Расписание весенней сессии ВШПМ СПбГУПТД ИПТО (Очная ф.о.) 2024-2025 уч.года.xls`;
  return (a) ? (URL + a) : '';
}
function cutLinkSprImtVech(){
  const a = ``;//`Расписание весенней сессии ВШПМ ИМТ СПбГУПТД (Очно-заочная ф.о.) 2025-2026 уч.года.xls`//`Расписание весенней сессии ВШПМ СПбГУПТД ИМТ (Очно-заочная ф.о.) 2024-2025 уч.года.xls`;
  return (a) ? (URL + a) : '';
}
function cutLinkSprIptoVech(){
  const a = ``;//`Расписание весенней сессии ВШПМ ИПТО СПбГУПТД (Очно-заочная ф.о.) 2025-2026 уч.года.xls`
  return (a) ? (URL + a) : '';
}
//Поиск ссылок на расписания занятий для очников и вечерников
async function getExcelLinks(){
    const response = await request(URL)
    return [{
      //Семестры
      semimtoch: (testBuild) ? cutLinkSemImtOch() : cutLinkOchSemestr('Институт медиатехнологий', response),
      semiptoch: (testBuild) ? cutLinkSemIptoOch() : cutLinkOchSemestr('Институт полиграфических технологий и оборудования', response),
      semimtvech: (testBuild) ? cutLinkSemImtVech() : cutLinkOchZaochSemestr('Институт медиатехнологий', response),
      semiptovech: (testBuild) ? cutLinkSemIptoVech() : cutLinkOchZaochSemestr('Институт полиграфических технологий и оборудования', response),
      //Pимняя или летняя сессия
      sesimtoch: (testBuild) ? cutLinkSesImtOch() : cutLinkOchSession('Институт медиатехнологий', response),
      sesiptooch: (testBuild) ? cutLinkSesIptoOch() : cutLinkOchSession('Институт полиграфических технологий и оборудования', response),
      sesimtvech: (testBuild) ? cutLinkSesImtVech() : cutLinkOchZaochSession('Институт медиатехнологий', response),
      sesiptovech: (testBuild) ? cutLinkSesIptoVech() : cutLinkOchZaochSession('Институт полиграфических технологий и оборудования', response),
      //Вессенняя сессия
      sessprimtoch: (testBuild) ? cutLinkSprImtOch() : cutLinkOchSpringSession('Институт медиатехнологий', response),
      sesspriptooch: (testBuild) ? cutLinkSprIptoOch() : cutLinkOchSpringSession('Институт полиграфических технологий и оборудования', response),
      sessprimtvech: (testBuild) ? cutLinkSprImtVech() : cutLinkOchZaochSpringSession('Институт медиатехнологий', response),
      sesspriptovech: (testBuild) ? cutLinkSprIptoVech() : cutLinkOchZaochSpringSession('Институт полиграфических технологий и оборудования', response)
}]
}
const excelLinks = await getExcelLinks()

async function download(url){
  if(url){
    const resoponse = await fetch(url); // Скачиваем информацию с файла по URL в виде http://.../....xls
    const buffer = await resoponse.arrayBuffer(); // Переводим информацию к структуре массива
    const file = read(buffer, {type:'array'}); // Читаем книгу как массив
    for(let i in file.Sheets){ // Читаем листы книги
      const listData = utils.sheet_to_json(file.Sheets[i], {header: 1}) // Считываем данные из листа
      if(listData.length > 0){ // Если данные есть передаем
        //console.log(listData)
        return listData
      }
    }
  }
}

function getsCalendar(){ // Формирование календаря
  let weeks = []; // Общий массив всех недель
  let week = []; // Массив одной недели
  let months = []; // Общий массив всех месяцев
  let currentweekdata = {currentweek: null/*, currentday: null/*, firstday:null, lastday: null, dateweekdays: null*/};
  let additionalyYear = 0; // Дополнительное значение года
  let additionalyMonth = 8; // Дополнительное значение месяца, 8 - сентябрь
  const currentCalendarYear = new Date().getFullYear(); // Текущий год
  const beginCurrentCalendarMonth = (additionalyMonth-1>7)?-12:0; // Если текущий год не соответствует учебному прибавляем 12 месяцев
  let dayIndex = new Date(currentCalendarYear + additionalyYear, beginCurrentCalendarMonth + additionalyMonth, 1).getDay(); // Высчитываем день недели
  if (dayIndex === 0){ // Первый день месяца (0 - вс, 1 - пн... )
      dayIndex = 7 // Преобразуем, чтобы воскресенье был 7ой
  }
  let weekIndex = 0; // Индекс массива одной недели
  let firstWeekCalendar = true; // Первая неделя учебного календаря
  let isToday = false;
  //let isTodayWeek = false;
  for(let countWeek = 1; countWeek < 61; countWeek++){ // Для простоты количество недель считаем до 60
    let firstDayOfCurrentMonth = new Date(currentCalendarYear + additionalyYear, beginCurrentCalendarMonth + additionalyMonth, 7).getDay(); // Первый день текущего месяца
    let lastDayOfLastMonth = beginCurrentCalendarMonth + additionalyMonth == 0 ? new Date(currentCalendarYear + additionalyYear-1, 11, 0).getDate() : new Date(currentCalendarYear + additionalyYear, beginCurrentCalendarMonth + additionalyMonth, 0).getDate(); // Последний день предыдущего месяца для первого месяца учебного календаря
    let k = lastDayOfLastMonth - firstDayOfCurrentMonth+1; // Расчет дней последней недели предыдущего месяца первого ученого месяца
    if(firstWeekCalendar){ // Если первая неделя учебного календаря
      for (let x = 0; x < dayIndex-1; x++) { // Проходим все дни первой недели учебного календаря
          week[x] = new Date(currentCalendarYear + additionalyYear, beginCurrentCalendarMonth + additionalyMonth-1, k).toLocaleDateString("en-US")
          weekIndex++;
          k++;
      }
      firstWeekCalendar = false;
    }
    let countDaysInCurrentMonth = new Date(currentCalendarYear + additionalyYear, beginCurrentCalendarMonth + additionalyMonth + 1, 0).getDate(); // Количество дней в текущем вычисляемом месяце
    for (let day = 1; day <= countDaysInCurrentMonth; day++) {
      let firstDayIndexWeek = new Date(currentCalendarYear + additionalyYear, beginCurrentCalendarMonth + additionalyMonth, day).getDay(); // Высчитываем день недели
      if (firstDayIndexWeek === 0){ // Первый день месяца (0 - вс, 1 - пн... )
          firstDayIndexWeek = 7 // Преобразуем, чтобы воскресенье был 7ой
      }
      week[weekIndex] = new Date(currentCalendarYear + additionalyYear, beginCurrentCalendarMonth + additionalyMonth, day).toLocaleDateString("en-US");
      const currentDay = new Date(currentCalendarYear + additionalyYear, beginCurrentCalendarMonth + additionalyMonth, day).getDate();
      const currentMonth = new Date(currentCalendarYear + additionalyYear, beginCurrentCalendarMonth + additionalyMonth, day).getMonth();
      const currentYear = new Date(currentCalendarYear + additionalyYear, beginCurrentCalendarMonth + additionalyMonth, day).getFullYear();
      isToday = currentDay === new Date().getDate() && currentMonth === new Date().getMonth() && currentYear === new Date().getFullYear();
      //console.log(currentMonth)
      if(isToday && (currentMonth === 7 && currentDay > 24)){ 
        console.log('Текущий день', day)
        console.log(weeks.length)
        //currentweekdata.currentday = new Date(currentYear,currentMonth,currentDay).toLocaleString("en-US");
        //currentweekdata.currentweek = weeks.length+1;
        currentweekdata.currentweek = weeks.length-3;
        //isTodayWeek = true;
      } else if (isToday){ console.log("#")
        currentweekdata.currentweek = weeks.length+1; //console.log(currentweekdata)
      }
      weekIndex++;
      if(weekIndex == 7) { // Если последний день воскресенье
        weeks.push(week); // Записываем недель в массив календаря
        //if(isTodayWeek){
          //currentweekdata.firstday = week[0];
          //currentweekdata.lastday = week[week.length-1];
          //currentweekdata.dateweekdays = week;
          
        //}
        week = []; // Обнуляем неделю
        weekIndex = 0; // Обнуляем индекс недель
        countWeek++; // Увеличиваем счетчик недель
        //isTodayWeek = false;
      }
      if(day == countDaysInCurrentMonth){
        let currentMonth = new Date(currentCalendarYear + additionalyYear, beginCurrentCalendarMonth + additionalyMonth, day).toLocaleDateString('ru-RU',{ month: 'long', year: 'numeric'});
        months.push(currentMonth)
        if(additionalyMonth == 11){
            additionalyYear++;
            additionalyMonth = 0;
        } else {
            additionalyMonth++;
        }
      }
    }
  }
  if(weeks.length > 49) { // Ограничиваем массив месяцев июлем, массив недель 48 неделью
    months.length = 11;
    weeks.length = 49;
  }
  let vacationseason = null;
  const today = new Date();
  if (isNaN(today.getTime())) return null; // Проверка на корректность даты
  const month = today.getMonth() + 1; // В JS месяцы идут от 0 до 11
  const day = today.getDate();
  // Зимние каникулы: с 31 декабря по 8 января
  /*if ((month === 12 && day === 31) || (month === 1 && day <= 8)) {
    return vacationseason = 'winter';
  }*/
  // Летние каникулы: с 10 июля по 15 августа
  if ((month === 7 && day >= 10) || (month === 8 && day <= 15)) {
    return vacationseason = 'summer';
  }
  //console.log(currentweekdata)
  //console.log(months, weeks, currentweekdata)
  return [{months, weeks, currentweekdata, vacationseason}]
}

export default new Vuex.Store({
  state: {
    testBuild: testBuild,
    calendar: [{
      months: null,
      weeks: null,
      currentweekdata: {
        currentweek: null
      },
      vacationseason: null
    }],
    defaultschoolcalendar: [{
      firstsemestr: [1, 16],
      wintersession: [17, 23],
      secondsemestr: [24, 40],
      springsession: [33, 35],
      summersession: [41, 44]
    }],
    
    semestrimtoch: null,
    semestriptooch: null,
    semestrimtvech: null,
    semestriptovech: null,
    sessionimtoch: null,
    sessioniptooch: null,
    sessionimtvech: null,
    sessioniptovech: null,
    sessionimtochspring: null,
    sessionimtvechspring: null,
    sessioniptoochspring: null,
    sessioniptovechspring: null,
    semestrsessionzaoch: null,// ?
    sessionimtiptozaoch: null,// ?
    selectedLevel: 0,
    selectedForm: 0,
    selectedKurs: 0,
    selectedInstitut: 0,
    inputGroupName: '',
    inputPrepodSurname: ''
  },
  mutations: {
    set(state, set){ // выводит список всех переменных, когда устанавливаем значения
      for(let k in set){
          state[k]=set[k]                
      } //console.log(set)
    },
  },
  actions: {
    async onLoad({commit}){
      let calendar = getsCalendar();
      let semestrimtoch = await download(excelLinks[0].semimtoch);
      let semestriptooch = await download(excelLinks[0].semiptoch);
      let semestrimtvech = await download(excelLinks[0].semimtvech);
      let semestriptovech = await download(excelLinks[0].semiptovech);
      let sessionimtoch = await download(excelLinks[0].sesimtoch);
      let sessioniptooch = await download(excelLinks[0].sesiptooch);
      let sessionimtvech = await download(excelLinks[0].sesimtvech);
      let sessioniptovech = await download(excelLinks[0].sesiptovech);
      let sessionimtochspring = await download(excelLinks[0].sessprimtoch);
      let sessionimtvechspring = await download(excelLinks[0].sessprimtvech);
      let sessioniptoochspring = await download(excelLinks[0].sesspriptooch);
      let sessioniptovechspring = await download(excelLinks[0].sesspriptovech);
      commit('set', {
        calendar, 
        semestrimtoch, 
        semestriptooch, 
        semestrimtvech, 
        semestriptovech, 
        sessionimtoch, 
        sessioniptooch, 
        sessionimtvech, 
        sessioniptovech, 
        sessionimtochspring, 
        sessionimtvechspring,
        sessioniptoochspring,
        sessioniptovechspring
      })
    }
  },
  getters:{
    semestrIptoOchGroups(state){
      const arr = new Set(state.semestriptooch?.[4].filter(v => v?.split('-').length > 1) ?? [])
      return [...arr] // Возвращает список групп
    },
    semestrImtOchGroups(state){
      const arr = new Set(state.semestrimtoch?.[4].filter(v => v?.split('-').length > 1) ?? [])
      return [...arr] // Возвращает список групп
    },
    semestrIptoVechGroups(state){
      const arr = new Set(state.semestriptovech?.[4].filter(v => v?.split('-').length > 1) ?? [])
      return [...arr] // Возвращает список групп
    },
    semestrImtVechGroups(state){
      const arr = new Set(state.semestrimtvech?.[4].filter(v => v?.split('-').length > 1) ?? [])
      return [...arr] // Возвращает список групп
    },
    sessionIptoOchGroup(state){
      const arr = state.sessioniptooch?.map(r => r[1]).filter(v => v?.split('-').length > 1).reduce((acc, item) => acc.includes(item) ? acc : [...acc, item], []).filter(w => w.length <=8) ?? [];
      return [...arr] // Возвращает список групп
    },
    sessionImtOchGroup(state){
      const arr = state.sessionimtoch?.map(r => r[1]).filter(v => v?.split('-').length > 1).reduce((acc, item) => acc.includes(item) ? acc : [...acc, item], []).filter(w => w.length <=8) ?? [];
      return [...arr] // Возвращает список групп
    },
    sessionIptoVechGroup(state){
      const arr = state.sessioniptovech?.map(r => r[1]).filter(v => v?.split('-').length > 1).reduce((acc, item) => acc.includes(item) ? acc : [...acc, item], []).filter(w => w.length <=8) ?? [];
      return [...arr] // Возвращает список групп
    },
    sessionImtVechGroup(state){
      const arr = state.sessionimtvech?.map(r => r[1]).filter(v => v?.split('-').length > 1).reduce((acc, item) => acc.includes(item) ? acc : [...acc, item], []).filter(w => w.length <=8) ?? [];
      return [...arr] // Возвращает список групп
    },
    sessionIptoOchSpringGroup(state){
      const arr = state.sessioniptoochspring?.map(r => r[1]).filter(v => v?.split('-').length > 1).reduce((acc, item) => acc.includes(item) ? acc : [...acc, item], []).filter(w => w.length <=8) ?? [];
      return [...arr] // Возвращает список групп
    },
    sessionImtOchSpringGroup(state){
      const arr = state.sessionimtochspring?.map(r => r[1]).filter(v => v?.split('-').length > 1).reduce((acc, item) => acc.includes(item) ? acc : [...acc, item], []).filter(w => w.length <=8) ?? [];
      return [...arr] // Возвращает список групп
    },
    sessionIptoVechSpringGroup(state){
      const arr = state.sessioniptovechspring?.map(r => r[1]).filter(v => v?.split('-').length > 1).reduce((acc, item) => acc.includes(item) ? acc : [...acc, item], []).filter(w => w.length <=8) ?? [];
      return [...arr] // Возвращает список групп
    },
    sessionImtVechSpringGroup(state){
      const arr = state.sessionimtvechspring?.map(r => r[1]).filter(v => v?.split('-').length > 1).reduce((acc, item) => acc.includes(item) ? acc : [...acc, item], []).filter(w => w.length <=8) ?? [];
      return [...arr] // Возвращает список групп
    },
    getCalendar(state){
      const arr = (state.calendar) ?? [];
      return [...arr] // Вернуть массив учебного календаря с неделями
    },
    isVacationSeason(state){
      const arr = (state.calendar[0]?.vacationseason) ?? [];
      return arr
    },
    getCurrentNumberWeek(state){//console.log(state.calendar[0])
      const arr = (state.calendar[0]?.currentweekdata) ?? {};
      return arr // Вернуть номер текущей недели
    },
    getDefaultSchoolCalendar(state){
      const arr = (state.defaultschoolcalendar[0]) ?? {};
      return arr // Вернуть обьект календарь по умолчанию с неделями
    },
    halfYearImtIptoSemestr(state){
      const imtoch = state.semestrimtoch?.[0].filter(v => v.split(' '))[0].split(' ')[8] ?? '';
      const imtvech = state.semestrimtvech?.[0].filter(v => v.split(' '))[0].split(' ')[8] ?? '';
      const iptooch = state.semestriptooch?.[0].filter(v => v.split(' '))[0].split(' ')[8] ?? '';
      const iptovech = state.semestriptovech?.[0].filter(v => v.split(' '))[0].split(' ')[8] ?? '';
      //console.log('imtoch:', imtoch, 'imtvech:',imtvech, 'iptooch:',iptooch, 'iptovech:',iptovech)
      /*console.log(
        state.semestrimtoch?.[0],
        state.semestrimtvech?.[0],
        state.semestriptooch?.[0],
        state.semestriptovech?.[0]
      )*/
      return (imtoch && imtvech && iptooch && iptovech); // Вернуть полугодие сессии (либо 1е, либо 2е) или empty
    },
    halfYearImtIptoSession(state){
      const imtochses = (state.sessionimtoch?.length > 0) ? state.sessionimtoch?.[2].filter(v => v?.split(' '))[0].split(' ')[6] : '';
      const imtvechses = (state.sessionimtvech?.length > 0) ? state.sessionimtvech?.[2].filter(v => v?.split(' '))[0].split(' ')[6] : '';
      const iptoochses = (state.sessioniptooch?.length > 0) ? state.sessioniptooch?.[2].filter(v => v?.split(' '))[0].split(' ')[6] : '';
      const iptovechses = (state.sessioniptovech?.length > 0) ? state.sessioniptovech?.[2].filter(v => v?.split(' '))[0].split(' ')[6] : '';
      //console.log(imtochses && imtvechses && iptoochses && iptovechses)
      return (imtochses && imtvechses && iptoochses && iptovechses); // Вернуть полугодие сессии (либо 1е, либо 2е) или empty
    },
    halfYearImtIptoSpringSession(state){
      const imtochsprses = (state.sessionimtochspring?.length > 0) ? state.sessionimtochspring?.[2].filter(v => v.split(' '))[0].split(' ')[6] : '';
      const imtvechsprses = (state.sessionimtvechspring?.length > 0) ? state.sessionimtvechspring?.[2].filter(v => v.split(' '))[0].split(' ')[6] : '';
      const iptoochsprses = (state.sessionimtvechspring?.length > 0) ? state.sessioniptoochspring?.[2].filter(v => v.split(' '))[0].split(' ')[6] : '';
      const iptovechsprses = (state.sessioniptovechspring?.length > 0) ? state.sessioniptovechspring?.[2].filter(v => v.split(' '))[0].split(' ')[6] : '';
      //console.log(imtochsprses, imtvechsprses, iptoochsprses, !iptovechsprses)
      return (imtochsprses && imtvechsprses && iptoochsprses && iptovechsprses); // Вернуть полугодие сессии (либо 1е, либо 2е) или empty
    },
    getNumberWeekStartSessionGroup(){
      return function(group, document, calendar){
        if(document){
          const a = document.filter(v => v?.includes(group))[0][2];
          let date = new Date();
          if(a.length > 6){ // Если зимняя сессия
            const b = a.split(' ')[0].split('.'); // Получить дата начала сессии в виде массива
            date = new Date(`${b[2]}`, `${b[1]-1}`, `${b[0]}`).toLocaleDateString("en-US"); // Переводим вормат в английский формат
          } else { // Если летняя сессия
            date = new Date((a - 25569) * 86400 * 1000).toLocaleDateString("en-US")
          }
          const numberWeek = calendar.findIndex((v, i) => {if(v.includes(date)){ return i}})+1; // Фактическое неделя отличается от недели из массива на 1 в большую сторону
          return numberWeek // Вернуть номер недели начала сессии
        } else return '';
      }
    },
    getNumberWeekEndSessionGroup(){
      return function(group, document, calendar){
        if(document){
          const a = document.filter(v => v?.includes(group))[0][3];
          let date = new Date();
          if(a.length > 6){ // Если зимняя сессия
            const c = a.split(' ');
            const b = c[c.length-1].split('.'); // Получить дата начала сессии в виде массива
            date = new Date(`${b[2]}`, `${b[1]-1}`, `${b[0]}`).toLocaleDateString("en-US"); // Переводим вормат в английский формат
          } else { // Если летняя сессия
            date = new Date((a - 25569) * 86400 * 1000).toLocaleDateString("en-US")
          }
          const numberWeek = calendar.findIndex((v, i) => {if(v.includes(date)){ return i}})+1; // Фактическое неделя отличается от недели из массива на 1 в большую сторону
          return numberWeek // Вернуть номер недели конца сессии
        } else return '';
      }
    },
    getNumberWeekStartAllSessionTeacher(state){
      return function(teacher, calendar){
        const a1 = state.sessionimtoch?.slice(4).filter(v => v?.includes(teacher)).map(row => {
          if(row[2].length > 6){
            const dateStr = row[2].split(/\s+/)[0];
            const [d, m, y] = dateStr.split('.');
            return new Date(`${y}-${m}-${d}`).getTime()
          } else {
            return new Date((row[2] - 25569) * 86400 * 1000)
          }
        });
        const a2 = state.sessioniptooch?.slice(4).filter(v => v?.includes(teacher)).map(row => {
          if(row[2].length > 6){
            const dateStr = row[2].split(/\s+/)[0];
            const [d, m, y] = dateStr.split('.');
            return new Date(`${y}-${m}-${d}`).getTime()
          } else {
            return new Date((row[2] - 25569) * 86400 * 1000)
          }
        });
        const a3 = state.sessionimtvech?.slice(4).filter(v => v?.includes(teacher)).map(row => {
          if(row[2].length > 6){
            const dateStr = row[2].split(/\s+/)[0];
            const [d, m, y] = dateStr.split('.');
            return new Date(`${y}-${m}-${d}`).getTime()
          } else {
            return new Date((row[2] - 25569) * 86400 * 1000)
          }
        });
        const a4 = state.sessioniptovech?.slice(4).filter(v => v?.includes(teacher)).map(row => {
          if(row[2].length > 6){
            const dateStr = row[2].split(/\s+/)[0];
            const [d, m, y] = dateStr.split('.');
            return new Date(`${y}-${m}-${d}`).getTime()
          } else {
            return new Date((row[2] - 25569) * 86400 * 1000)
          }
        });
        let numberWeek = null;
        if(a1 && a2 && a3 && a4){
          const date = new Date(Math.min(...a1,...a2,...a3,...a4)).toLocaleDateString("en-US");
          numberWeek = calendar.findIndex((v, i) => {
            if(v.includes(date)){ return i}
          })+1;
        }
        return numberWeek;
      }
    },
    getNumberWeekEndAllSessionTeacher(state){
      return function(teacher, calendar){
        const a1 = state.sessionimtoch?.slice(4).filter(v => v?.includes(teacher)).map(row => {
          if(row[3].length > 6){
            const c = row[3].split(' ');
            const b = c[c.length-1];
            const [d, m, y] = b.split('.');
            return new Date(`${y}-${m}-${d}`).getTime()
          } else {
            return new Date((row[3] - 25569) * 86400 * 1000)
          }
        });
        const a2 = state.sessioniptooch?.slice(4).filter(v => v?.includes(teacher)).map(row => {
          if(row[3].length > 6){
            const c = row[3].split(' ');
            const b = c[c.length-1];
            const [d, m, y] = b.split('.');
            return new Date(`${y}-${m}-${d}`).getTime()
          } else {
            return new Date((row[3] - 25569) * 86400 * 1000)
          }
        });
        const a3 = state.sessionimtvech?.slice(4).filter(v => v?.includes(teacher)).map(row => {
          if(row[3].length > 6){
            const c = row[3].split(' ');
            const b = c[c.length-1];
            const [d, m, y] = b.split('.');
            return new Date(`${y}-${m}-${d}`).getTime()
          } else {
            return new Date((row[3] - 25569) * 86400 * 1000)
          }
        });
        const a4 = state.sessioniptovech?.slice(4).filter(v => v?.includes(teacher)).map(row => {
          if(row[3].length > 6){
            const c = row[3].split(' ');
            const b = c[c.length-1];
            const [d, m, y] = b.split('.');
            return new Date(`${y}-${m}-${d}`).getTime()
          } else {
            return new Date((row[3] - 25569) * 86400 * 1000)
          }
        });
        let numberWeek = null;
        if(a1 && a2 && a3 && a4){
          const date = new Date(Math.max(...a1,...a2,...a3,...a4)).toLocaleDateString("en-US");
          numberWeek = calendar.findIndex((v, i) => {
            if(v.includes(date)){ return i}
          })+1;
        }
        //console.log(a1, a2, a3, a4)
        return numberWeek;
      }
    },
    getSessionDataGroup(){
      return function(document, group){
        const data = document.filter(
          (v) => v[1]?.includes(group.trim())
        ); //(v) => v?.includes(group)
        return data;
      }
    },
    sessionDataGroup(){
      return function(group){
        if(this.sessionImtOchGroup.includes(group)){
          return this.sessionimtoch;
        } else if(this.sessionImtVechGroup.includes(group)){
          return this.sessionimtvech;
        } else if(this.sessionIptoOchGroup.includes(group)){
          return this.sessioniptooch;
        } else if(this.sessionIptoVechGroup.includes(group)){
          return this.sessioniptovech;
        } return[];
      }
    },
    sessionSpringDataGroup(){
      return function(group){
        if(this.sessionImtOchSpringGroup.includes(group)){
          return this.sessionimtochspring;
        } else if(this.sessionImtVechSpringGroup.includes(group)){
          return this.sessionimtvechspring;
        } else if(this.sessionIptoOchSpringGroup.includes(group)){
          return this.sessioniptoochspring;
        } else if(this.sessionIptoVechSpringGroup.includes(group)){
          return this.sessioniptovechspring;
        } return[];
      }
    },
    semestrDataGroup(){
      return function(group){
        if(this.semestrIptoOchGroups.includes(group)){     
          return this.semestriptooch;
        } else if(this.semestrImtOchGroups.includes(group)){
          return this.semestrimtoch;
        } else if(this.semestrIptoVechGroups.includes(group)){
          return this.semestriptovech;
        } else if(this.semestrImtVechGroups.includes(group)){
          return this.semestrimtvech;
        } return[];
      }
    },
    /*getSemestrData(){
      return function(document, group, isWeekUp){
        const indexGroup = document[4]?.indexOf(group) // Вычисляем индекс столбца группы
        const Numerator = [];
        const Denominator = []
        const DayNameInDocumentn = document?.map(v => v[0]).slice(5) // Столбец наименование недели из документа группы
        const dayTimeInDocumentn = document?.map(v => v[1]).slice(5) // Столбец времени занятий из документа группы
        const decriptionsInDocument = document.map(v => v[indexGroup]).slice(5) // Столбец предметов группы начиная с 6 строки (5 строка наименование группы)
        const roomsInDocument = document.map(v => v[indexGroup+1]).slice(5) // Столбец помещений группы начиная с 6 строки (5 строка наименование группы)
        const decriptionsNumerator = decriptionsInDocument.filter((_,i) => i%2 ===0) // Данные предметов группы только по числителю
        const roomsNumerator = roomsInDocument.filter((_,i) => i%2 ===0) // Данные помещений группы только по числителю
        const decriptionsDenominator = decriptionsInDocument.filter((_,i) => i%2 !==0) // Данные предметов группы только по знаменателю
        const roomsDenominator = roomsInDocument.filter((_,i) => i%2 !==0) // Данные помещений группы только по знаменателю
        Numerator.push(decriptionsNumerator);
        Numerator.push(roomsNumerator)
        Denominator.push(decriptionsDenominator);
        Denominator.push(roomsDenominator);
        console.log(newDocument)
        return (isWeekUp) ? Numerator : Denominator;
      }
    },*/
    semestrImtIptoOchVechPrepod(state){
      const imtoch = state.semestrimtoch?.slice(4); // Подгружаем данные таблицы семестров деканата ИМТ очное
      const iptooch = state.semestriptooch?.slice(4); // Подгружаем данные таблицы семестров деканата ИПТО очное
      const imtvech = state.semestrimtvech?.slice(4); // Подгружаем данные таблицы семестров деканата ИМТ очное-заочное
      const iptovech = state.semestriptovech?.slice(4); // Подгружаем данные таблицы семестров деканата ИПТО очное-заочное
      const imtOchGroupIndex = imtoch?.[0]?.map((el, idx) => el.includes('-') ? idx : -1).filter(idx => idx !== -1) || []; // Вычесляем индексы групп (уникальные)
      const iptoOchGroupIndex = iptooch?.[0]?.map((el, idx) => el.includes('-') ? idx : -1).filter(idx => idx !== -1) || []; // Вычесляем индексы групп (уникальные)
      const imtVechGroupIndex = imtvech?.[0]?.map((el, idx) => el.includes('-') ? idx : -1).filter(idx => idx !== -1) || []; // Вычесляем индексы групп (уникальные)
      const iptoVechGroupIndex = iptovech?.[0]?.map((el, idx) => el.includes('-') ? idx : -1).filter(idx => idx !== -1) || []; // Вычесляем индексы групп (уникальные)
      const semImtOchData = imtoch?.slice(1).map(row => row.filter((_,i) => imtOchGroupIndex.includes(i))) // Из подгруженных Дат оставляем только предметы с преподователями
      const semIptoOchData = iptooch?.slice(1).map(row => row.filter((_,i) => iptoOchGroupIndex.includes(i))) // Из подгруженных Дат оставляем только предметы с преподователями
      const semImtVechData = imtvech?.slice(1).map(row => row.filter((_,i) => imtVechGroupIndex.includes(i))) // Из подгруженных Дат оставляем только предметы с преподователями
      const semIptoVechData = iptovech?.slice(1).map(row => row.filter((_,i) => iptoVechGroupIndex.includes(i))) // Из подгруженных Дат оставляем только предметы с преподователями
      const regex = /[А-Я][а-яё]+\s+[А-Я]\.[А-Я]\.?\.?/gu; // Регулярное выражения для поиска ФИО
      const arraySemImtOchPrepod = semImtOchData?.flatMap(row => row.map(item => item.match(regex)?.[0] || '')).filter(Boolean) || []; // Вычисляем ФИО преподавателей
      //console.log(semIptoOchData)
      //const arraySemIptoOchPrepod = semIptoOchData?.flatMap(row => row.map(item => item.match(regex)?.[0] || '')).filter(Boolean) || []; // Вычисляем ФИО преподавателей
      const arraySemIptoOchPrepod = semIptoOchData?.flatMap(row => row.map(item => {
        return item.match(regex)?.[0] || ''
      })).filter(Boolean) || []; // Вычисляем ФИО преподавателей
      //console.log(...new Set(arraySemIptoOchPrepod))
      const arraySemImtVechPrepod = semImtVechData?.flatMap(row => row.map(item => item.match(regex)?.[0] || '')).filter(Boolean) || []; // Вычисляем ФИО преподавателей
      const arraySemIptoVechPrepod = semIptoVechData?.flatMap(row => row.map(item => item.match(regex)?.[0] || '')).filter(Boolean) || []; // Вычисляем ФИО преподавателей
      //const arraySesImtOchPrepod = state.sessionimtoch?.slice(4).map(r => r[7]).filter(Boolean).flatMap(item => item.match(regex)?.[0] || []).filter(Boolean) || [];
      const arraySesImtOchPrepod = state.sessionimtoch?.slice(4).map(r => r[7]).filter(Boolean).flatMap(item => {const matches = [...item.matchAll(regex)];return matches.length > 1 ? matches[1] : matches[0];}).filter(Boolean) || [];
      const arraySesIptoOchPrepod = state.sessioniptooch?.slice(4).map(r => r[7]).filter(Boolean).flatMap(item => {const matches = [...item.matchAll(regex)];return matches.length > 1 ? matches[1] : matches[0];}).filter(Boolean) || [];
      const arraySesImtVechPrepod = state.sessionimtvech?.slice(4).map(r => r[7]).filter(Boolean).flatMap(item => {const matches = [...item.matchAll(regex)];return matches.length > 1 ? matches[1] : matches[0];}).filter(Boolean) || [];
      const arraySesIptoVechPrepod = state.sessioniptovech?.slice(4).map(r => r[7]).filter(Boolean).flatMap(item => {const matches = [...item.matchAll(regex)];return matches.length > 1 ? matches[1] : matches[0];}).filter(Boolean) || [];
      return [...new Set([...arraySemImtOchPrepod, ...arraySemIptoOchPrepod, ...arraySemImtVechPrepod, ...arraySemIptoVechPrepod, ...arraySesImtOchPrepod, ...arraySesIptoOchPrepod, ...arraySesImtVechPrepod, ...arraySesIptoVechPrepod])] // Возвращает список всех преподователей (уникальный)
    },
    semestrOrAndSessionDataTeacher(state){
      return function(teacher, epoch){
        //console.log('@',teacher)
        let result = [];
            const semImtOch = state.semestrimtoch?.slice(4);
            const semIptoOch = state.semestriptooch?.slice(4);
            const semImtVech = state.semestrimtvech?.slice(4);
            const semIptoVech = state.semestriptovech?.slice(4);
            const sesImtOch = state.sessionimtoch?.slice(5);
            const sesIptoOch = state.sessioniptooch?.slice(5);
            const sesImtVech = state.sessionimtvech?.slice(5);
            const sesIptoVech = state.sessioniptovech?.slice(5);
            const sesSprImtOch = state.sessionimtochspring?.slice(5);
            const sesSprIptoOch = state.sessioniptoochspring?.slice(5);
            const sesSprImtVech = state.sessionimtvechspring?.slice(5);
            const sesSprIptoVech = state.sessioniptovechspring?.slice(5);
            const findINSemImtOch = semImtOch?.reduce((acc, row, rowIndex) => {
                row.forEach((value, colIndex) => {
                    if (value.includes(teacher)) {
                        acc.push({rowIndex: rowIndex, groupIndex: colIndex, discription: value});
                    }
                });
                return acc;
            }, []);
            const findINSemIptoOch = semIptoOch?.reduce((acc, row, rowIndex) => {
                row.forEach((value, colIndex) => {
                    if (value.includes(teacher)) {
                        acc.push({rowIndex: rowIndex, groupIndex: colIndex, discription: value});
                    }
                });
                return acc;
            }, []);
            const findINSemImtVech = semImtVech?.reduce((acc, row, rowIndex) => {
                row.forEach((value, colIndex) => {
                    if (value.includes(teacher)) {
                        acc.push({rowIndex: rowIndex, groupIndex: colIndex, discription: value});
                    }
                });
                return acc;
            }, []);
            const findINSemIptoVech = semIptoVech?.reduce((acc, row, rowIndex) => {
                row.forEach((value, colIndex) => { 
                    if (value.includes(teacher)) {
                        acc.push({rowIndex: rowIndex, groupIndex: colIndex, discription: value});
                    } 
                });
                return acc;
            }, []);
            const arraySesImtOchPrepod = sesImtOch?.reduce((acc, row, rowIndex) => {
                if(row[7]?.includes(teacher)) acc.push({rowIndex: rowIndex, discription: row});
                return acc;
            }, [])
            const arraySesIptoOchPrepod = sesIptoOch?.reduce((acc, row, rowIndex) => {
                if(row[7]?.includes(teacher)) acc.push({rowIndex: rowIndex, discription: row});
                return acc;
            }, [])
            const arraySesImtVechPrepod = sesImtVech?.reduce((acc, row, rowIndex) => {
                if(row[7]?.includes(teacher)) acc.push({rowIndex: rowIndex, discription: row});
                return acc;
            }, [])
            const arraySesIptoVechPrepod = sesIptoVech?.reduce((acc, row, rowIndex) => {
                if(row[7]?.includes(teacher)) acc.push({rowIndex: rowIndex, discription: row});
                return acc;
            }, [])
            const arraySesSprImtOchPrepod = sesSprImtOch?.reduce((acc, row, rowIndex) => {
                if(row[7]?.includes(teacher)) acc.push({rowIndex: rowIndex, discription: row});
                return acc;
            }, [])
            const arraySesSprIptoOchPrepod = sesSprIptoOch?.reduce((acc, row, rowIndex) => {
                if(row[7]?.includes(teacher)) acc.push({rowIndex: rowIndex, discription: row});
                return acc;
            }, [])
            const arraySesSprImtVechPrepod = sesSprImtVech?.reduce((acc, row, rowIndex) => {
                if(row[7]?.includes(teacher)) acc.push({rowIndex: rowIndex, discription: row});
                return acc;
            }, [])
            const arraySesSprIptoVechPrepod = sesSprIptoVech?.reduce((acc, row, rowIndex) => {
                if(row[7]?.includes(teacher)) acc.push({rowIndex: rowIndex, discription: row});
                return acc;
            }, [])
            if(findINSemImtOch && findINSemIptoOch && findINSemImtVech && findINSemIptoVech){
                findINSemImtOch.forEach((value) => {//console.log(value)
                    const dayIndex = (Math.floor((value.rowIndex-1) / 12) * 12)+1;
                    const timeIndex = value.rowIndex % 2 === 0 ? value.rowIndex - 1 : value.rowIndex;
                    const day = semImtOch[dayIndex][0];
                    const time = semImtOch[timeIndex][1];
                    const dics = value.discription;
                    const room = semImtOch[value.rowIndex][value.groupIndex+1]?.trim().replace(/\s+/g, ' ');
                    const isWeekUp = (value.rowIndex % 2) ? false : true;
                    const group = semImtOch[0][value.groupIndex]
                    //console.log(value)
                    result.push({_:0,a:value.rowIndex,b:dayIndex,epoch:epoch,group:group,day:day,time:time,dics:dics,room:room,isweekup:isWeekUp,type:0})
                })
                findINSemIptoOch.forEach((value) => {//console.log(value)
                    const dayIndex = (Math.floor((value.rowIndex-1) / 12) * 12)+1;
                    const timeIndex = value.rowIndex % 2 === 0 ? value.rowIndex - 1 : value.rowIndex;
                    const day = semIptoOch[dayIndex][0];
                    const time = semIptoOch[timeIndex][1]
                    const dics = value.discription;
                    const room = semIptoOch[value.rowIndex][value.groupIndex+1]?.trim().replace(/\s+/g, ' ');
                    const isWeekUp = (value.rowIndex % 2) ? false : true;
                    const group = semIptoOch[0][value.groupIndex]
                    //console.log(value) 
                    result.push({_:0,a:value.rowIndex,b:dayIndex,epoch:epoch,group:group,day:day,time:time,dics:dics,room:room,isweekup:isWeekUp,type:0})
                })
                findINSemImtVech.forEach((value) => {//console.log(value)
                    const dayIndex = (value.rowIndex>20) ? 21 : (Math.floor((value.rowIndex-1) / 4) * 4)+1;
                    const timeIndex = value.rowIndex % 2 === 0 ? value.rowIndex - 1 : value.rowIndex;
                    const day = semImtVech[dayIndex][0];
                    const time = semImtVech[timeIndex][1]
                    const dics = value.discription;
                    const room = semImtVech[value.rowIndex][value.groupIndex+1]?.trim().replace(/\s+/g, ' ');
                    const isWeekUp = (value.rowIndex % 2) ? false : true;
                    const group = semImtVech[0][value.groupIndex]
                    //console.log(value)
                    //console.log({i:value.rowIndex,_:0,epoch:epoch,group:group,day:day,time:time,dics:dics,room:room,isweekup:isWeekUp,type:0})
                    result.push({_:0,epoch:epoch,group:group,day:day,time:time,dics:dics,room:room,isweekup:isWeekUp,type:0})
                })
                findINSemIptoVech.forEach((value) => {//console.log(value)
                    const dayIndex = (value.rowIndex>20) ? 21 : (Math.floor((value.rowIndex-1) / 4) * 4)+1;
                    const timeIndex = value.rowIndex % 2 === 0 ? value.rowIndex - 1 : value.rowIndex;
                    const day = semIptoVech[dayIndex][0];
                    const time = semIptoVech[timeIndex][1]
                    const dics = value.discription;
                    const room = semIptoVech[value.rowIndex][value.groupIndex+1]?.trim().replace(/\s+/g, ' ');
                    const isWeekUp = (value.rowIndex % 2) ? false : true;
                    const group = semIptoVech[0][value.groupIndex]
                    //console.log(value)
                    //console.log({i:value.rowIndex,_:0,epoch:epoch,group:group,day:day,time:time,dics:dics,room:room,isweekup:isWeekUp,type:0})
                    result.push({_:0,epoch:epoch,group:group,day:day,time:time,dics:dics,room:room,isweekup:isWeekUp,type:0})
                })
            }
            if(arraySesImtOchPrepod && arraySesIptoOchPrepod && arraySesImtVechPrepod && arraySesIptoVechPrepod){
                arraySesImtOchPrepod.forEach((value) => {
                  let day = '';
                  let date = '';
                  if(value.discription[9].length > 6){
                    const [d, m, y] = value.discription[9].split('.');
                    date = new Date(`${y}-${m}-${d}`).toLocaleDateString("en-US");
                    let dayGetDay = new Date(`${y}-${m}-${d}`).getDay();
                    if (dayGetDay === 0){ dayGetDay = 7 }
                    day = this.dayName[dayGetDay-1];
                  } else {
                    date = new Date((value.discription[9] - 25569) * 86400 * 1000).toLocaleDateString("en-US");
                    let dayGetDay = new Date((value.discription[9] - 25569) * 86400 * 1000).getDay();
                    if (dayGetDay === 0){ dayGetDay = 7 }
                    day = this.dayName[dayGetDay-1];
                  }
                    const excelEpoch = new Date(Date.UTC(1899, 11, 30));
                    const excelMs = (value.discription[10] - 1) * 24 * 60 * 60 * 1000;
                    const jsDateInMs = excelEpoch.getTime() + excelMs;
                    const jsDate = new Date(jsDateInMs);
                    const hours = jsDate.getUTCHours();
                    const minutes = jsDate.getUTCMinutes();
                    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
                    const group = value.discription[1];
                    const disc = value.discription[4];
                    const type = value.discription[8];
                    const room = value.discription[11];
                    const prepod = value.discription[7];
                    result.push({_:1,epoch:epoch,day:day,date:date,time:formattedTime,group:group,disc:disc,lessontype:type,room:room,prepod:prepod})
                });
                arraySesIptoOchPrepod.forEach((value) => {
                    let day = '';
                    let date = '';
                    if(value.discription[9].length > 6){
                      const [d, m, y] = value.discription[9].split('.');
                      date = new Date(`${y}-${m}-${d}`).toLocaleDateString("en-US");
                      let dayGetDay = new Date(`${y}-${m}-${d}`).getDay();
                      if (dayGetDay === 0){ dayGetDay = 7 }
                      day = this.dayName[dayGetDay-1];
                    } else {
                      date = new Date((value.discription[9] - 25569) * 86400 * 1000).toLocaleDateString("en-US");
                      let dayGetDay = new Date((value.discription[9] - 25569) * 86400 * 1000).getDay();
                      if (dayGetDay === 0){ dayGetDay = 7 }
                      day = this.dayName[dayGetDay-1];
                    }
                    const excelEpoch = new Date(Date.UTC(1899, 11, 30));
                    const excelMs = (value.discription[10] - 1) * 24 * 60 * 60 * 1000;
                    const jsDateInMs = excelEpoch.getTime() + excelMs;
                    const jsDate = new Date(jsDateInMs);
                    const hours = jsDate.getUTCHours();
                    const minutes = jsDate.getUTCMinutes();
                    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
                    const group = value.discription[1];
                    const disc = value.discription[4];
                    const type = value.discription[8];
                    const room = value.discription[11];
                    const prepod = value.discription[7];
                    result.push({_:1,epoch:epoch,day:day,date:date,time:formattedTime,group:group,disc:disc,lessontype:type,room:room,prepod:prepod})
                });
                arraySesImtVechPrepod.forEach((value) => {
                  let day = '';
                  let date = '';
                  if(value.discription[9].length > 6){
                    const [d, m, y] = value.discription[9].split('.');
                    date = new Date(`${y}-${m}-${d}`).toLocaleDateString("en-US");
                    let dayGetDay = new Date(`${y}-${m}-${d}`).getDay();
                    if (dayGetDay === 0){ dayGetDay = 7 }
                    day = this.dayName[dayGetDay-1];
                  } else {
                    date = new Date((value.discription[9] - 25569) * 86400 * 1000).toLocaleDateString("en-US");
                    let dayGetDay = new Date((value.discription[9] - 25569) * 86400 * 1000).getDay();
                    if (dayGetDay === 0){ dayGetDay = 7 }
                    day = this.dayName[dayGetDay-1];
                  }
                    const excelEpoch = new Date(Date.UTC(1899, 11, 30));
                    const excelMs = (value.discription[10] - 1) * 24 * 60 * 60 * 1000;
                    const jsDateInMs = excelEpoch.getTime() + excelMs;
                    const jsDate = new Date(jsDateInMs);
                    const hours = jsDate.getUTCHours();
                    const minutes = jsDate.getUTCMinutes();
                    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
                    const group = value.discription[1];
                    const disc = value.discription[4];
                    const type = value.discription[8];
                    const room = value.discription[11];
                    const prepod = value.discription[7];
                    result.push({_:1,epoch:epoch,day:day,date:date,time:formattedTime,group:group,disc:disc,lessontype:type,room:room,prepod:prepod})
                });
                arraySesIptoVechPrepod.forEach((value) => {
                  let day = '';
                  let date = '';
                  if(value.discription[9].length > 6){
                    const [d, m, y] = value.discription[9].split('.');
                    date = new Date(`${y}-${m}-${d}`).toLocaleDateString("en-US");
                    let dayGetDay = new Date(`${y}-${m}-${d}`).getDay();
                    if (dayGetDay === 0){ dayGetDay = 7 }
                    day = this.dayName[dayGetDay-1];
                  } else {
                    date = new Date((value.discription[9] - 25569) * 86400 * 1000).toLocaleDateString("en-US");
                    let dayGetDay = new Date((value.discription[9] - 25569) * 86400 * 1000).getDay();
                    if (dayGetDay === 0){ dayGetDay = 7 }
                    day = this.dayName[dayGetDay-1];
                  }
                    const excelEpoch = new Date(Date.UTC(1899, 11, 30));
                    const excelMs = (value.discription[10] - 1) * 24 * 60 * 60 * 1000;
                    const jsDateInMs = excelEpoch.getTime() + excelMs;
                    const jsDate = new Date(jsDateInMs);
                    const hours = jsDate.getUTCHours();
                    const minutes = jsDate.getUTCMinutes();
                    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
                    const group = value.discription[1];
                    const disc = value.discription[4];
                    const type = value.discription[8];
                    const room = value.discription[11];
                    const prepod = value.discription[7];
                    result.push({_:1,epoch:epoch,day:day,date:date,time:formattedTime,group:group,disc:disc,lessontype:type,room:room,prepod:prepod})
                });
            }
            if(arraySesSprImtOchPrepod && arraySesSprIptoOchPrepod && arraySesSprImtVechPrepod && !arraySesSprIptoVechPrepod){
                arraySesSprImtOchPrepod.forEach((value) => {
                  let day = '';
                  let date = '';
                  if(value.discription[9].length > 6){
                    const [d, m, y] = value.discription[9].split('.');
                    date = new Date(`${y}-${m}-${d}`).toLocaleDateString("en-US");
                    let dayGetDay = new Date(`${y}-${m}-${d}`).getDay();
                    if (dayGetDay === 0){ dayGetDay = 7 }
                    day = this.dayName[dayGetDay-1];
                  } else {
                    date = new Date((value.discription[9] - 25569) * 86400 * 1000).toLocaleDateString("en-US");
                    let dayGetDay = new Date((value.discription[9] - 25569) * 86400 * 1000).getDay();
                    if (dayGetDay === 0){ dayGetDay = 7 }
                    day = this.dayName[dayGetDay-1];
                  }
                    const excelEpoch = new Date(Date.UTC(1899, 11, 30));
                    const excelMs = (value.discription[10] - 1) * 24 * 60 * 60 * 1000;
                    const jsDateInMs = excelEpoch.getTime() + excelMs;
                    const jsDate = new Date(jsDateInMs);
                    const hours = jsDate.getUTCHours();
                    const minutes = jsDate.getUTCMinutes();
                    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
                    const group = value.discription[1];
                    const disc = value.discription[4];
                    const type = value.discription[8];
                    const room = value.discription[11];
                    const prepod = value.discription[7];
                    result.push({_:2,epoch:epoch,day:day,date:date,time:formattedTime,group:group,disc:disc,lessontype:type,room:room,prepod:prepod})
                });
                arraySesSprIptoOchPrepod.forEach((value) => {
                  let day = '';
                  let date = '';
                  if(value.discription[9].length > 6){
                    const [d, m, y] = value.discription[9].split('.');
                    date = new Date(`${y}-${m}-${d}`).toLocaleDateString("en-US");
                    let dayGetDay = new Date(`${y}-${m}-${d}`).getDay();
                    if (dayGetDay === 0){ dayGetDay = 7 }
                    day = this.dayName[dayGetDay-1];
                  } else {
                    date = new Date((value.discription[9] - 25569) * 86400 * 1000).toLocaleDateString("en-US");
                    let dayGetDay = new Date((value.discription[9] - 25569) * 86400 * 1000).getDay();
                    if (dayGetDay === 0){ dayGetDay = 7 }
                    day = this.dayName[dayGetDay-1];
                  }
                    const excelEpoch = new Date(Date.UTC(1899, 11, 30));
                    const excelMs = (value.discription[10] - 1) * 24 * 60 * 60 * 1000;
                    const jsDateInMs = excelEpoch.getTime() + excelMs;
                    const jsDate = new Date(jsDateInMs);
                    const hours = jsDate.getUTCHours();
                    const minutes = jsDate.getUTCMinutes();
                    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
                    const group = value.discription[1];
                    const disc = value.discription[4];
                    const type = value.discription[8];
                    const room = value.discription[11];
                    const prepod = value.discription[7];
                    result.push({_:2,epoch:epoch,day:day,date:date,time:formattedTime,group:group,disc:disc,lessontype:type,room:room,prepod:prepod})
                });
                arraySesSprImtVechPrepod.forEach((value) => {
                  let day = '';
                  let date = '';
                  if(value.discription[9].length > 6){
                    const [d, m, y] = value.discription[9].split('.');
                    date = new Date(`${y}-${m}-${d}`).toLocaleDateString("en-US");
                    let dayGetDay = new Date(`${y}-${m}-${d}`).getDay();
                    if (dayGetDay === 0){ dayGetDay = 7 }
                    day = this.dayName[dayGetDay-1];
                  } else {
                    date = new Date((value.discription[9] - 25569) * 86400 * 1000).toLocaleDateString("en-US");
                    let dayGetDay = new Date((value.discription[9] - 25569) * 86400 * 1000).getDay();
                    if (dayGetDay === 0){ dayGetDay = 7 }
                    day = this.dayName[dayGetDay-1];
                  }
                    const excelEpoch = new Date(Date.UTC(1899, 11, 30));
                    const excelMs = (value.discription[10] - 1) * 24 * 60 * 60 * 1000;
                    const jsDateInMs = excelEpoch.getTime() + excelMs;
                    const jsDate = new Date(jsDateInMs);
                    const hours = jsDate.getUTCHours();
                    const minutes = jsDate.getUTCMinutes();
                    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
                    const group = value.discription[1];
                    const disc = value.discription[4];
                    const type = value.discription[8];
                    const room = value.discription[11];
                    const prepod = value.discription[7];
                    result.push({_:2,epoch:epoch,day:day,date:date,time:formattedTime,group:group,disc:disc,lessontype:type,room:room,prepod:prepod})
                });
                arraySesSprIptoVechPrepod?.forEach((value) => {
                  let day = '';
                  let date = '';
                  if(value.discription[9].length > 6){
                    const [d, m, y] = value.discription[9].split('.');
                    date = new Date(`${y}-${m}-${d}`).toLocaleDateString("en-US");
                    let dayGetDay = new Date(`${y}-${m}-${d}`).getDay();
                    if (dayGetDay === 0){ dayGetDay = 7 }
                    day = this.dayName[dayGetDay-1];
                  } else {
                    date = new Date((value.discription[9] - 25569) * 86400 * 1000).toLocaleDateString("en-US");
                    let dayGetDay = new Date((value.discription[9] - 25569) * 86400 * 1000).getDay();
                    if (dayGetDay === 0){ dayGetDay = 7 }
                    day = this.dayName[dayGetDay-1];
                  }
                    const excelEpoch = new Date(Date.UTC(1899, 11, 30));
                    const excelMs = (value.discription[10] - 1) * 24 * 60 * 60 * 1000;
                    const jsDateInMs = excelEpoch.getTime() + excelMs;
                    const jsDate = new Date(jsDateInMs);
                    const hours = jsDate.getUTCHours();
                    const minutes = jsDate.getUTCMinutes();
                    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
                    const group = value.discription[1];
                    const disc = value.discription[4];
                    const type = value.discription[8];
                    const room = value.discription[11];
                    const prepod = value.discription[7];
                    result.push({_:2,epoch:epoch,day:day,date:date,time:formattedTime,group:group,disc:disc,lessontype:type,room:room,prepod:prepod})
                });
            }
            //console.log(result)
            return result;
      }
    },
    ExcelLinks(){
      return excelLinks
    }
  },

  modules: {
  }
})